/**
 * EXPERIMENTAL — uses DOM MutationObserver to detect viewer loading screen appearance/disappearance.
 * To revert: delete this file and remove its usages in product-config and product-design-edit components.
 *
 * When a choice is selected, the v3.0 viewer prepends <div class="loading-screen"> to its container.
 * This is the DOM equivalent of v2.6 configurationChangeInitiatedEventName — fires at the same moment.
 * Used to clear the price immediately so the user sees visual feedback before the new price is calculated.
 *
 * The same loading-screen also appears on non-config transitions (e.g. entering/leaving the Sectional
 * Builder), which do NOT emit configurationChangedEvent. For those cases onFinished fires on removal
 * so callers can restore the price with a fallback getConfiguration() fetch.
 *
 * Returns a cleanup function (call in ngOnDestroy).
 */
export function setupConfigurationChangeInitiatedListener(
  viewerHostElement: HTMLElement,
  onInitiated: () => void,
  onFinished?: () => void
): () => void {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of Array.from(mutation.addedNodes)) {
        if (node instanceof HTMLElement && node.classList.contains("loading-screen")) {
          onInitiated();
        }
      }
      if (onFinished) {
        for (const node of Array.from(mutation.removedNodes)) {
          if (node instanceof HTMLElement && node.classList.contains("loading-screen")) {
            onFinished();
          }
        }
      }
    }
  });

  observer.observe(viewerHostElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
